/* eslint import/first: 0 */
import Vue from 'vue'
import i18n from 'utils/i18n'

import Automount from 'utils/automount'

import AwardApp from 'award/AwardApp.vue'
/* eslint one-var: 0 */
/* eslint no-var: 0 */
/* eslint no-plusplus: 0 */
/* eslint no-new: 0 */
document.addEventListener('DOMContentLoaded', () => {
  Automount('.js-award-app', AwardApp, { i18n })
})
